module.exports = __webpack_public_path__ + "img/volunters.06bf2ec2.webp";